import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/navbar";
import MainPage from "./components/pages/mainPage";
import Footer from "./components/footer";
import { ThemeProvider, createTheme } from "@mui/material";

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: ["'VT323'", "monospace"].join(","),
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Navbar />
        <MainPage />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
